if (!customElements.get('vto-modal')) {
  customElements.define(
    'vto-modal',
    class VTOModal extends ModalDialog {
      constructor() {
        super();
        this.iframe = this.querySelector('#vto-iframe');
        this.loader = this.querySelector('.vto-modal__loader');
        this.iframe.addEventListener('load', () => this.setLoading(false));
      }

      setLoading(isLoading) {
        if (this.loader) this.loader.hidden = !isLoading;
      }

      connectedCallback() {
        if (this.moved) return; // super.connectedCallback() re-triggers this method, but sets moved = true
        super.removeAllOthers();
        super.connectedCallback();
      }

      hide() {
        super.hide();
        // Unload the embed so the camera stream is released when the modal closes.
        this.iframe.setAttribute('src', '');
        this.setLoading(true);
      }

      show(opener) {
        super.show(opener);
        var currentURL = this.iframe.getAttribute('src');
        var newURL = this.openedBy.getAttribute('data-url');
        if (currentURL !== newURL) {
          this.setLoading(true);
          this.iframe.setAttribute('src', newURL);
        }

        // Each opener describes its own experience (try-on vs 3D viewer).
        var label = this.openedBy.getAttribute('data-modal-label');
        if (label) {
          this.querySelectorAll('[role="dialog"], [role="document"]').forEach(function (el) {
            el.setAttribute('aria-label', label);
          });
        }
      }
    }
  );
}
